export const LocationIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
        <path
            fill="#8C8C8C"
            d="M12.75 7.5A3.749 3.749 0 0 0 9 3.75 3.749 3.749 0 0 0 5.25 7.5c0 .366.127.867.39 1.486.255.607.613 1.266 1.02 1.924.8 1.296 1.745 2.536 2.342 3.281.596-.745 1.542-1.985 2.342-3.28.405-.66.766-1.32 1.022-1.925.257-.619.384-1.12.384-1.486Zm.75 0c0 2.048-2.742 5.695-3.945 7.2a.708.708 0 0 1-1.11 0C7.242 13.195 4.5 9.548 4.5 7.5a4.501 4.501 0 0 1 9 0Zm-5.625 0a1.125 1.125 0 1 0 2.25 0 1.125 1.125 0 0 0-2.25 0ZM9 9.375a1.875 1.875 0 1 1 0-3.75 1.875 1.875 0 0 1 0 3.75Z"
        />
    </svg>
);
